import BaseComponent from 'foundation/base-component';
import Cookies from 'js-cookie';

export default class MyAccountUrlComponent extends BaseComponent {
    constructor(...args) {
        super(...args);

        this.init();
    }

    init() {
        const isUseCognito = this.options.useCognito;
        const secutixCookie = Cookies.get('secutixConfig');

        if (secutixCookie !== undefined && isUseCognito === false) {
            const secutixConfiguration = JSON.parse(secutixCookie);
            this.element.setAttribute('href', secutixConfiguration.myAccountUrl);
        }
    }
}
